import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const getCurrentTimestamp = () => Math.ceil(Date.now() / 1000);

export const getDate = (days = 0) => {
  const date = new Date();
  if (days) {
    date.setDate(date.getDate() + days);
  }
  return date;
};

export const formatDate = (inputDate, format = 'MM-DD-YYYY') => {
  if (!inputDate) return '';

  return dayjs(inputDate).format(format);
};

export const formatTimestamp = (inputTimestamp, format = 'MM-DD-YYYY') => {
  if (!inputTimestamp) return '';

  return dayjs(inputTimestamp * 1000).format(format);
};

export const formatDateToUtc = (inputDate) => {
  if (!inputDate) return '';

  return dayjs(inputDate).utc().format();
};

export const formatTimestampToUtc = (inputTimestamp) => {
  if (!inputTimestamp) return '';

  return dayjs(inputTimestamp * 1000)
    .utc()
    .format();
};

export const getISOWeekNumber = (date) => {
  const tempDate = new Date(date);
  tempDate.setHours(0, 0, 0, 0);

  tempDate.setDate(tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7));

  const firstThursday = new Date(tempDate.getFullYear(), 0, 4);

  const weekNumber = Math.ceil(
    ((tempDate - firstThursday) / 86400000 + firstThursday.getDay() + 1) / 7
  );

  return weekNumber;
};

export const getSundaysForSpecificYear = (year) => {
  const weeklyDates = [];
  const date = new Date(year, 0, 1);

  while (date.getDay() !== 0) {
    date.setDate(date.getDate() + 1);
  }

  while (date.getFullYear() === year) {
    const weekNumber = getISOWeekNumber(new Date(date));

    weeklyDates.push({
      date: formatDate(date, 'YYYY-MM-DD'),
      week: weekNumber,
    });
    date.setDate(date.getDate() + 7);
  }

  return weeklyDates;
};

const getQuarter = (date) => `Q${Math.floor((date.getMonth() + 3) / 3)}`;

export const getSundaysBetween = (startDate, endDate) => {
  const sundays = [];

  const start = startDate ? new Date(startDate) : new Date();
  const end = endDate ? new Date(endDate) : new Date();

  if (!startDate && !endDate) {
    start.setDate(start.getDate() - 7);
    end.setDate(end.getDate() + 63);
  }

  while (start.getDay() !== 0) {
    start.setDate(start.getDate() + 1);
  }

  while (start <= end) {
    sundays.push({
      date: formatDate(start, 'MM/DD/YY'),
      week: getISOWeekNumber(start),
      quarter: getQuarter(start),
    });
    start.setDate(start.getDate() + 7);
  }

  return sundays;
};
